module.exports = __webpack_public_path__ + "assets/images_base/st-avatar.svg?v=a24f0c33";